export type FormDataType = {
  rejectMessage: string;
};

export const formDataInitialState: FormDataType = {
  rejectMessage: '',
};
